import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AppConfigService } from './app-config.service';
import { StorageService} from './storage.service';


@Injectable()
export class AuthenticationService {
  // private apiUrl: string;

  constructor(private _http: HttpClient,
              private _appConfig: AppConfigService) {
  }

  logout() {
      // remove user from local storage to log user out
      localStorage.removeItem('patientId');
      localStorage.removeItem('currentUser');
      localStorage.removeItem('validation-cgu');
      localStorage.removeItem('compte-expire');
      localStorage.removeItem('firstPatientId');
      localStorage.removeItem('patients');
      localStorage.removeItem('patientCurrent');
      localStorage.removeItem('doubleauthent');
      // console.log('** logout **');
  }

    login(username: string, password: string) {
        const apiUrl = this._appConfig.config.servicesBaseUrl;
        return this._http.post<any>(apiUrl + `/auth/login`, { login: username, password: password })
            .pipe(map(response => {
                if (response && response.token) {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('currentUser', JSON.stringify(response));
                    localStorage.setItem('compte-expire', JSON.stringify(response.expired));
                    localStorage.setItem('validation-cgu', JSON.stringify(response.validationCGU));
                    localStorage.setItem('type', JSON.stringify(response.type));
                }
                return response;
            }));
    }
}

